export const GA_TRACKING_ID = process.env.REACT_GA_ID as string;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: URL): void => {
  window.gtag("set", "page_path", url);
  window.gtag("event", "page_view", { send_to: GA_TRACKING_ID });
};
